// import api from '@/plugins/api'
// import router from '@/plugins/router'
import names from '@/configs/app_names'

const state = {
    ordering: [
        { text: 'Name (A-Z)', value: 'name' },
        { text: 'Name (Z-A)', value: '-name' }
    ],
    headers: [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Loop Duration', align: 'left', value: 'loop_duration' },
        { text: 'Segments', align: 'left', sortable: false, class: 'hidden-xs-only' },
        { text: `${names.locations.label.singular} Count`, align: 'left', sortable: false, class: 'hidden-xs-only' },
        // { text: 'Ordering Strategy', align: 'left', sortable: false, class: 'hidden-xs-only' },
        { text: '', align: 'left', sortable: false, class: 'hidden-sm-and-up' }
    ],
    pagination: {
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        page: 1,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
    },
    query: {
        limit: 10,
        offset: 0,
        q: undefined,
        ordering: undefined,
        paging: undefined
    },
    orderingStrategies: [
        { text: 'Distribute by Category', value: 'DISTRIBUTE_BY_CATEGORY' }
    ]
}

const getters = {
    orderingStrategies ({ orderingStrategies }) {
        return orderingStrategies
    }
}

const mutations = {
    setPagination (state, payload) {
        state.pagination = payload        
    },
    // setPaginationTotalItems (state, payload) {
    //     state.pagination.totalItems = payload
    // },
    setPaginationDescending (state, payload) {
        state.pagination.sortDesc = payload        
    },
    setPaginationSortBy (state, payload) {
        state.pagination.sortBy = payload        
    },
    // setQuery (state, payload) {
    //     state.query = payload        
    // },
    setQueryLimit (state, payload) {
        state.query.limit = payload
    },
    setQueryOffset (state, payload) {
        state.query.offset = payload
    },
    setQuerySearch (state, payload) {
        state.query.q = payload
    },
    setQueryOrdering (state, payload) {
        state.query.ordering = payload
    },
    setQueryPaging (state, payload) {
        state.query.paging = payload
    }
}

const actions = {
    setPagination({ commit }, payload) {
        commit('setPagination', payload)
        if ( payload.itemsPerPage> 0 ) {
            commit('setQueryLimit', payload.itemsPerPage)
            commit('setQueryOffset', (payload.page - 1) * payload.itemsPerPage)
            commit('setQueryPaging', undefined)
        } else {
            commit('setQueryLimit', undefined)
            commit('setQueryOffset', undefined)
            commit('setQueryPaging', 'none')
        }
        if ( payload.sortBy[0] ) {
            if ( payload.sortDesc[0] ) {                
                commit('setQueryOrdering', `-${payload.sortBy[0]}`)  
            } else {
                commit('setQueryOrdering', payload.sortBy[0])
            }
        } else {
            commit('setQueryOrdering', undefined)
        }
    },
    resetPagination({ state, commit, dispatch }) {
        dispatch('setPagination', {
            sortDesc: [],
            page: 1,
            itemsPerPage: state.pagination.itemsPerPage, 
            sortBy: [],
            // totalItems: 0
        })
        commit('setQuerySearch', undefined)
    },
    setOrdering({ commit }, payload) {
        commit('setQueryOrdering', payload)
        if ( payload ) {
            if ( payload.startsWith('-') ) {
                commit('setPaginationDescending', [true])
                commit('setPaginationSortBy', [payload.slice(1)])
            } else {
                commit('setPaginationDescending', [])
                commit('setPaginationSortBy', [payload])
            }
        } else {
            commit('setPaginationDescending', [])
            commit('setPaginationSortBy', [])
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
